const STATE = {
  connectorModal: {
    show: false,
    loading: false,
    data: {},
  },
  connector: {},
  connectors: [],
  salesforceNewConnectors: [],
  dynamoNewConnectors: [],
  dynamoConnectorsList: null,
  dynamoEndpointsConfig: null,
  loadingDuringAdding: false,
  isPreviewLoading: false,
  isAllSchemasWithReadEnabled: false,
  dynamoPreview: {
    entityLabel: null,
    data: null,
  },
  dynamoEndpointConfigurationModal: {
    isOpen: false,
    data: null,
  },
  dynamoDescriptionSchemaModal: {
    isOpen: false,
    data: null,
  },
  loading: false,
  preview: {
    data: [],
    loading: false,
  },
  salesforceNewPreview: {
    data: [],
    loading: false,
  },

  endpoint: {
    modal: {
      show: false,
      loading: false,
      data: {},
    },
    loading: false,
  },
  staticEndpoints: {
    data: [],
  },
  salesforceNewStaticEndpoints: {
    data: [],
  },
  endpointEntryColumns: {},
  startingPoint: {
    modal: {
      show: false,
      loading: false,
      data: {},
    },
    loading: false,
    pitchBookEndpoints: {},
    entityNameEndpoints: [
      {value: 'CompanyEndpoints', name: 'Companies API', collapse: false},
      {value: 'DealEndpoints', name: 'Deals API', collapse: false},
      {value: 'InvestorEndpoints', name: 'Investors API', collapse: false},
      {value: 'PeopleEndpoints', name: 'People API', collapse: false},
      {value: 'FundEndpoints', name: 'Funds API', collapse: false},
      {value: 'LimitedPartnersEndpoints', name: 'Limited Partners API', collapse: false},
      {value: 'ServiceProvidersEndpoints', name: 'Service Providers API', collapse: false},
    ],
  },
  disableDuringRequest: false,
};

export default STATE;
